module.exports = __webpack_public_path__ + "img/modulo-4.c292cb46.svg";